import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { Header } from './-header/-components';
import { IssueDetailOutletWithForm } from './_layout/-context/issue-tab-form-context';
import { IssueFormStore } from './_layout/-store/store';
export const Route = createFileRoute('/_stacktrace/issues/$id/_layout')({
  component: Layout
});
function Layout() {
  const store = IssueFormStore.createStore();
  return <IssueFormStore.Provider value={store}>
      <VStack>
        <Header />
        <IssueDetailOutletWithForm />
      </VStack>
    </IssueFormStore.Provider>;
}